import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { callTaskList } from "@/app/providers/directives/Resize/state"
import { callAllTaskList } from "@/app/providers/directives/Scroll/state"
import { setCookie } from "@/plugins/cookie";
import { useThrottle } from "@/shared/lib/utils"
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { locale } = useI18n();

locale.value = 'ru';

setCookie('language', 'ru')
localStorage.setItem('locale', 'ru');

const publicRoutes = ['/doc/', '/policy', '/auth', '/register'];

if (publicRoutes?.some?.(route => location?.href?.includes?.(route)) == false) {
    localStorage.setItem('location', location?.pathname + location?.search)
}


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _directive_resize_init = _resolveDirective("resize-init")!
  const _directive_scroll_window = _resolveDirective("scroll-window")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createVNode(_component_router_view, null, null, 512), [
      [_directive_resize_init, _unref(useThrottle)(_unref(callTaskList))]
    ])
  ])), [
    [_directive_scroll_window, _unref(callAllTaskList)]
  ])
}
}

})